import moment from 'moment';
import { getReportBySystemTypeApi } from '../../services/reportService';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, getLocale } from 'umi';
import { arrayRemoveElement } from '../../utils/common';
import { useClickAway, useInfiniteScroll, useDebounceEffect } from 'ahooks';
import { IS_GLOBAL } from '@/pages/home/_config/config';
import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import { buriedPointPage, buriedPointSearch } from '@/pages/home/utils/buriedPoint';
import { ReportProps } from './report';
import { CDN_URL_DOMAIN, COS_URL_DOMAIN } from '@intelligence/_config/config';
import { getReportLanguages, normalizeLanguage } from '@intelligence/utils/reportLanguage';
import { buildReportAuthors } from '@intelligence/components/ReportCard/authors';
import { splitReportTagStr } from '@intelligence/v3/utils/topcharts';
interface Result {
  list: [];
  nextId: number | undefined;
}
const transformAuthorAvatar = (avatar: string): string => avatar.replace(COS_URL_DOMAIN, CDN_URL_DOMAIN);

export const DEFAULT_ACTIVE_ID = 'All';

export default (props: ReportProps) => {
  const { reportType } = props;
  const [dataLoading, setLoading] = useState(true);
  const locale = getLocale();
  const [dataFull, setDataFull] = useState([]); // 当前条件下拥有的所有报告
  const [segmentList, setSegmentList] = useState<any>([]);
  const [activeId, setActiveId] = useState(DEFAULT_ACTIVE_ID); // 初始值为 All
  const [dataPartial, setDataPartial] = useState([]); // 当前tab下，搜索条件下，拥有的报告
  const [segmentValue, setSegmentValue] = useState<string>('all');
  const [cacheRecentSearch, setCacheRecentSearch] = useState<any>([]);

  const [showSearchRecent, setShowSearchRecent] = useState(false);
  const [showSearchRecentFixed, setShowSearchRecentFixed] = useState(false);
  const searchRecentProper = useRef<HTMLDivElement>(null);
  const searchRecentProperFixed = useRef<HTMLDivElement>(null);

  /** 搜索关键词 */
  const [search, setSearch] = useState<any>(null);
  const location = useLocation();
  const shareBack = location?.query?.id || '';

  const lazyScrollRef = useRef<HTMLDivElement>(null);

  const pageLogMes = dbiPageLogMes.gameResearchReport;

  /**
   * @description: 获得当前的语言
   * @return {*}
   */
  const lang = useMemo(() => {
    return locale === 'en-US' ? 1 : 0;
  }, [locale]);

  const searchTypeCur = useMemo(() => {
    switch (reportType) {
      case 'gameResearchReport':
        return 'gameResearchSearch';
      case 'insightsReports':
        return 'insightsReportSearch';
      default:
        return 'GameAnalysisSearch';
    }
  }, [reportType]);

  const getPdfName = (item: any) => {
    if (item.pdf && item.pdf != '') {
      return 2;
    }
    if (item.pdf_en && item.pdf_en != '') {
      return 1;
    }
    return 0;
  };

  const getReportMobileList = async () => {
    setLoading(true);
    try {
      const systemId = 'gameResearch';
      const res = await getReportBySystemTypeApi(systemId);
      const tmp: any = [];
      const tmpSegment: any = [];
      const dataListNew = [];
      const dataListTop = [];
      let tmpArrNew: any = [];
      const tmpSegmentList = [{ segment: '全部', segment_en: DEFAULT_ACTIVE_ID }];

      // 权限管控未上线，woa环境三角洲行动商业化报告先隐藏
      const resourceList = IS_GLOBAL
        ? res?.resource_list
        : res?.resource_list?.filter((item: any) => item.resource_id !== '47');

      if (Array.isArray(resourceList) && resourceList.length > 0) {
        resourceList?.forEach((item: any, index: any) => {
          // const time = moment(item.update_time).format('YYYY-MM-DD');
          const time = moment(item.create_time).format('YYYY-MM-DD');
          const coverImg = item.cover?.replace(COS_URL_DOMAIN, CDN_URL_DOMAIN);
          const obj = {
            ...item,
            key: index,
            resource_id: item.resource_id,
            // coverImg: item.cover,
            coverImg,
            // 筛选时高亮会修改 title, 给选中文案添加标签样式
            // 避免 title 变化有影响使用，保留原有 title 信息到 originTitle
            title: [item.title, item.title_en],
            originTitle: [item.title, item.title_en],
            report_type: [item.report_type, item.report_type_en],
            summary: [item.introduction, item.introduction_en],
            tag: [splitReportTagStr(item?.tag), splitReportTagStr(item?.tag_en)],
            time,
            source: item.source,
            authors: buildReportAuthors(item, { transformAvatar: transformAuthorAvatar }),
            report_like: item.report_like,
            update_time: item.update_time,
            create_time: item.create_time,
            reportLangeType: getPdfName(item), // 报告语言状态，0为中英报告都有，1只有英文报告，2只有中文报告
          };
          tmp.push(obj);
          if (!tmpSegment.includes(item.segment_en) && item.segment_en?.toLowerCase() !== 'all') {
            tmpSegment.push(item.segment_en);
            tmpSegmentList.push({ segment: item.segment, segment_en: item.segment_en });
          }
        });

        setSegmentList(tmpSegmentList);
      }

      if (tmp && Array.isArray(tmp) && tmp?.length > 0) {
        const dataArr = tmp;
        // eslint-disable-next-line no-restricted-syntax
        for (const n in dataArr) {
          // if (!!moment(dataArr[n].update_time).isAfter(moment().subtract(1, 'month'))) {
          if (!!moment(dataArr[n].create_time).isAfter(moment().subtract(1, 'month'))) {
            dataListNew.push(dataArr[n]);
          } else {
            dataListTop.push(dataArr[n]);
          }
        }
        dataListNew.sort((a, b) => {
          // return moment(b.update_time) - moment(a.update_time);
          return moment(b.create_time).valueOf() - moment(a.create_time).valueOf();
        });
        tmpArrNew = [...dataListNew, ...dataListTop];
      } else {
        tmpArrNew = [];
      }

      setDataFull(tmpArrNew);
      setDataPartial(tmpArrNew);
      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  const onSearch = (word: any) => {
    if (cacheRecentSearch.indexOf(word) == -1 && word != '') {
      const c = [...cacheRecentSearch];
      c.push(word);
      setCacheRecentSearch(c);
      localStorage.setItem(searchTypeCur, JSON.stringify(c));
    }

    onSearchRes(word);
    if (pageLogMes?.pageId) {
      buriedPointSearch({ extInfo: pageLogMes?.pageId, typeId: pageLogMes?.typeId }, word);
    }
  };

  useDebounceEffect(
    () => {
      if (search != null) {
        onSearch(search);
      }
    },
    [search],
    {
      leading: false,
      wait: 600,
    },
  );

  const getREGObj = (strTemp: any, keyWord: string) => {
    // 使用正则表达式的全局搜索标志match方法,计算高亮后数据与个数
    const itemUpper = strTemp.toUpperCase();
    if (itemUpper.indexOf(keyWord.toUpperCase()) != -1) {
      const replaceWord = strTemp.substr(itemUpper.indexOf(keyWord.toUpperCase()), keyWord.length);
      const replaceHtml = `<span style="color:#326ff0">${replaceWord}</span>`;
      const regExp = new RegExp(replaceWord, 'gi');
      return {
        txt: strTemp.replace(regExp, replaceHtml),
        num: strTemp.match(regExp)?.length || 0,
      };
    }
    return {
      txt: strTemp,
      num: 0,
    };
  };

  const onSearchRes = (wordValue: string, activeIdTemp = activeId) => {
    let newData: any = [];
    const tmpData =
      activeIdTemp === DEFAULT_ACTIVE_ID
        ? dataFull
        : dataFull?.filter((item: any) => item.segment_en === activeIdTemp);
    const word = typeof wordValue === 'string' ? wordValue?.trim() : '';
    if (typeof word === 'string' && word === '') {
      newData = tmpData;
    } else {
      tmpData.forEach((item: any, idx: any) => {
        const titleTemp = item.title[lang];
        const textTemp = item.summary[lang];
        const tagListTemp = item.tag[lang];
        let tagAllStr = '';
        if (Array.isArray(tagListTemp)) {
          for (const n in tagListTemp) {
            tagAllStr = tagAllStr + tagListTemp[n];
          }
        }
        const tagTempListData = [];
        let tagNumTotal = 0;
        // 高亮报告标题，并计算数量
        // 高亮报告描述内容，并计算数量
        // 高亮标签内容，并计算数量
        // if (titleTemp.toUpperCase().indexOf(word.toUpperCase()) != -1) {
        if ((titleTemp + textTemp + tagAllStr).toUpperCase().indexOf(word.toUpperCase()) != -1) {
          const resultTitleObj = getREGObj(titleTemp, word);
          const newTitle = resultTitleObj.txt;

          const resultTextObj = getREGObj(textTemp, word);
          // console.log('resultTextObjresultTextObj', resultTextObj);
          const newText = resultTextObj.txt;

          if (Array.isArray(tagListTemp) && tagListTemp?.length > 0) {
            for (const n in tagListTemp) {
              const resultTagObj = getREGObj(tagListTemp[n], word);
              tagTempListData.push(resultTagObj.txt);
              tagNumTotal = +resultTagObj.num;
            }
          }
          let titleList = [];
          let textList = [];
          let tagList = [];
          if (lang == 0) {
            titleList = [newTitle, item.title[1]];
            textList = [newText, item.summary[1]];
            tagList = [tagTempListData, item.tag[1]];
          } else {
            titleList = [item.title[0], newTitle];
            textList = [item.summary[0], newText];
            tagList = [item.tag[0], tagTempListData];
          }
          const obj = {
            ...item,
            key: idx,
            title: titleList,
            summary: textList,
            tag: tagList,
            searchTotalNum: resultTitleObj.num + resultTextObj.num + tagNumTotal,
            searchTitleNum: resultTitleObj.num,
            searchTextNum: resultTextObj.num,
            searchTagNum: tagNumTotal,
          };
          newData.push(obj);
        }
      });
    }
    setDataPartial(newData);
  };

  const getRecentSearchList = () => {
    try {
      const searchRecent = localStorage.getItem(searchTypeCur) || '[]';
      const searchRecentList = JSON.parse(searchRecent);
      const list = Array.isArray(searchRecentList) ? searchRecentList : [];
      setCacheRecentSearch(list);
    } catch (error) {
      console.log(error);
    }
  };

  // const getSegmentList = async () => {
  //   try {
  //     const resList = await getGameResearchReportSegment();
  //     if (Array.isArray(resList) && resList?.length > 0) {
  //       setSegmentList(resList);
  //     }
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  const onClear = () => {
    onSearchRes('');
  };

  useClickAway(() => {
    if (showSearchRecent) setShowSearchRecent(false);
  }, searchRecentProper);

  useClickAway(() => {
    if (showSearchRecentFixed) setShowSearchRecentFixed(false);
  }, searchRecentProperFixed);

  const handleSearchRecentClick = (item: any) => {
    setSearch(item);
  };

  const deleteSearchRecent = (e: any, index: any, item: any) => {
    const c = arrayRemoveElement(cacheRecentSearch, item);

    setCacheRecentSearch(c);
    localStorage.setItem(searchTypeCur, JSON.stringify(c));
  };

  const scrollDataSource = useMemo(() => {
    if (!dataPartial?.length) return [];
    if (segmentValue === 'all' || !segmentValue) return dataPartial;
    const normalizedSegment = normalizeLanguage(segmentValue);
    return dataPartial.filter((item: any) => {
      const { fileCnLang, fileEnLang } = getReportLanguages(item);
      return (
        (normalizeLanguage(fileCnLang) === normalizedSegment && item?.pdf !== '') ||
        (normalizeLanguage(fileEnLang) === normalizedSegment && item?.pdf_en !== '')
      );
    });
  }, [dataPartial, segmentValue]);

  function getLoadMoreList(nextId: number | undefined, limit: number): Promise<Result> {
    let start = 0;
    if (nextId) {
      start = scrollDataSource.findIndex((i) => i.key === nextId);
    }
    const end = start + limit;
    const list = scrollDataSource.slice(start, end);
    const nId = scrollDataSource[end] ? scrollDataSource[end].key : undefined;

    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          list,
          nextId: nId,
        });
      }, 500);
    });
  }

  const { data, loading, loadingMore, noMore, mutate } = useInfiniteScroll(
    (d) => getLoadMoreList(d?.nextId, 6),
    {
      target: lazyScrollRef,
      isNoMore: (d) => d?.nextId === undefined,
      reloadDeps: [scrollDataSource],
    },
  );

  const handleTabChange = (tab: any) => {
    setActiveId(tab.id);
    setSegmentValue('all');
    onSearchRes(search, tab.id);
  };

  const buriedPointPageCur = useMemo(() => {
    switch (reportType) {
      case 'gameResearchReport':
        return dbiPageLogMes.gameResearchReport;
      case 'insightsReports':
        return dbiPageLogMes.insightsReports;
      default:
        return dbiPageLogMes.gameAnalysisReport;
    }
  }, [reportType]);

  useEffect(() => {
    // 获取动态segment
    // getSegmentList();
    getRecentSearchList();
    getReportMobileList();
    buriedPointPage(buriedPointPageCur);
  }, []);

  return {
    segmentList,
    activeId,
    setActiveId,
    onSearch,
    showSearchRecent,
    showSearchRecentFixed,
    setShowSearchRecent,
    setShowSearchRecentFixed,
    searchRecentProper,
    searchRecentProperFixed,
    handleSearchRecentClick,
    deleteSearchRecent,
    cacheRecentSearch,
    dataLoading,
    dataPartial,
    lang,
    search,
    onClear,
    shareBack,
    setSearch,
    lazyScrollRef,
    data,
    loading,
    loadingMore,
    noMore,
    handleTabChange,
    mutate,
    segmentValue,
    setSegmentValue,
  };
};
